import { calculateLocatinVars } from '../../../libs/browser';
import { emailValidator } from '../../../libs/valid-rule';
import { getGrecaptchaToken, logoutAccount } from '../../../libs/state';
import { parseError } from '../../../libs/parser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackCloseBarComponent from '../../../components/BackCloseBarComponent';
import CommonIconButton from '../../../components/CommonIconButton';
import Context from '../../../provider';
import IconSuccess from '../../../assets/hkdc/icons/SuccessIcon';
import InputComponent from '../../../components/InputComponent';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import React, { useContext, useEffect, useState } from 'react';
import config from '../../../config';
import memberApi from '../../../libs/api/memberApi';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

const formValid = {
  email: emailValidator
};

export default function MobileLogin() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const notificationNotReadCount = useNotificationsCount();

  const { init, dispatch, me, appConfig } = useContext(Context);
  const [formData, setFormData] = useState({
    email: ''
  });

  // This page only allow logged in user
  useEffect(() => {
    if (init && me) {
      if (me.status === 'new') {
        logoutAccount({ dispatch });
      } else if (me.status === 'activated') {
        navigate(`${config.basename}`);
      }
    }
    window.scrollTo(0, 0);
  }, [init, me, navigate]);

  const forgetEmail = (e) => {
    e.stopPropagation();
    navigate(`${config.basename}setting/forgot-email`);
  };

  const handleButtonDisabled = () => {
    return !!formValid.email(formData.email, 'Email is required');
  };

  const submitLogin = async (e) => {
    e.preventDefault();
    const data = {
      countryCode: undefined,
      mobile: undefined,
      email: formData.email
    };
    const loginData = { ...data, username: data.email };
    if (appConfig.login_method === 'otp') {
      return await sendOtp(loginData);
    }
  };

  const sendOtp = async (loginData) => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      await memberApi.requestOtp({
        ...loginData,
        ...(appConfig?.recaptcha ? { gRecaptchaResponse: await getGrecaptchaToken(appConfig?.recaptcha) } : {})
      });
      navigate(`${config.basename}email-otp`, {
        state: {
          type: 'login',
          username: loginData.email
        }
      });
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  return (
    (
      <div className='mobile-login-page'>
        <BackCloseBarComponent onClick = {() => {
          navigate(`${config.basename}`);
        }} />
        <div className="content-container">
          <div className="success-title-container">
            <div className="success-icon-cont">
              <IconSuccess
                className="setting-tag-icon"
                size="large" />
            </div>
              <div className="title-text-cont">
                <div className="title-text">
                  {t('login-page.title')}
                </div>
              </div>
          </div>

          <div className="email-login-container">
            <form onSubmit={submitLogin} className="form-group">
              <InputComponent
                onValueChange={(value) => {
                  setFormData({
                    email: value
                  });
                }}
                label={t('login-page.field')}
                fullWidth={true}
                errorValue={''}
                errorCondition={() => false}
                validator={formValid.email}
              />
              <p
                className="forget-btn"
                onClick={forgetEmail}
              >
                {t('login-page.forgot-btn')}
              </p>
            </form>
            <CommonIconButton
              text={t('common.next-btn')}
              endIcon= {<KeyboardArrowRightIcon />}
              disabled={handleButtonDisabled()}
              btnWidth= "8.625rem"
              btnHeight= "2.375rem"
              onClick={submitLogin}
            />
            <div className="desc-cont">
              {
                t('login-page.t&c')
              }
            </div>
          </div>
        </div>
      </div>
    )
  );
}